// Dropdown value for "No folder"; folder options use their id as a string.
export const ROOT_DESTINATION = "root";
